import type { Verdict } from "./api";

/**
 * The six verdicts and the colour each wears (WORLD-1).
 *
 * One place, because the same six words appear on a relation in a dossier (UI-8), on the
 * insights behind a belief (UI-10), in the ledger's "By effect on beliefs" filter (UI-9)
 * and in the wiki itself — and the milestone's own instruction is that the vocabulary is
 * used *identically* everywhere. Two colour maps would be the first drift.
 *
 * The order is the one FEATURES.md lists them in, which is also roughly least to most
 * disruptive: `open` starts something, `challenge` disputes something.
 */
export const VERDICT_COLOUR: Record<Verdict, string> = {
  open: "var(--vl-bridge)",
  extend: "var(--vl-virtual)",
  corroborate: "var(--success)",
  weaken: "var(--warning)",
  supersede: "var(--vl-accent-warm)",
  challenge: "var(--destructive)",
};
